<template>
  <div class="section registration">
    <div class="container">
      <div class="columns is-centered is-vcentered">
        <div class="column is-three-fifths">
          <div class="form-box">
            <h3 class="has-text-centered" v-if="isLease === true">Tenant Registration</h3>
            <h3 class="has-text-centered" v-else>Homeowner Registration</h3>
            <b-steps :has-navigation="false" :mobile-mode="null" :value="activeStep">
              <b-step-item label="Validation" icon="account-key" :clickable="false"></b-step-item>
              <b-step-item label="Profile" icon="account" :clickable="false"></b-step-item>
              <b-step-item
                label="Confirmation"
                icon="account-plus"
                :clickable="false"
              ></b-step-item>
            </b-steps>
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
              <transition name="fade" mode="out-in" appear>
                <div v-if="status === STATUS_INIT" class="has-responsive-type has-text-centered">
                  <h4>Initializing...</h4>
                </div>
                <div
                  v-else-if="status === STATUS_LOADING"
                  class="has-responsive-type has-text-centered"
                >
                  <h4>Loading...</h4>
                </div>
                <div
                  v-else-if="status === STATUS_SUBMITTED"
                  class="has-responsive-type has-text-centered"
                >
                  <h4>Processing...</h4>
                </div>
                <div v-if="status === STATUS_CODE_VALID" class="has-responsive-type">
                  <h4>Please start by verifying your name and address.</h4>
                  <!-- <json-box :value="validUnit" /> -->
                  <div class="card">
                    <div
                      v-if="validUnit !== undefined && validUnit"
                      class="card-content has-text-centered"
                    >
                      <h5>{{ validUnit.ownerName || '' }}</h5>
                      <h6>
                        {{ validUnit.address.addressOne || '' }}
                        <br />
                        {{ validUnit.address.city || '' }}, {{ validUnit.address.state || '' }}
                        {{ validUnit.address.postalCode || '' }}
                      </h6>

                      <button class="button is-primary is-fullwidth is-medium" @click="verify">
                        Yes. This is me.
                      </button>
                    </div>
                    <div
                      v-else-if="validUnits !== undefined && validUnits"
                      class="card-content has-text-centered"
                    >
                      <div v-for="item in validUnits" :key="item.id">
                        <h5>{{ item.ownerName || '' }}</h5>
                        <h6>
                          {{ item.address.addressOne || '' }}
                          <br />
                          {{ item.address.city || '' }}, {{ item.address.state || '' }}
                          {{ item.address.postalCode || '' }}
                        </h6>
                        <h5>{{ '' }}</h5>
                        <div v-if="item.id === validUnits.length - 1">
                          <button
                            class="button is-primary is-fullwidth is-medium"
                            @click="verifyOwners"
                          >
                            Yes. These are correct.
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <form
                  v-else-if="status === STATUS_VERIFIED || status === STATUS_ERROR"
                  @submit.prevent="handleSubmit(onFormSubmit)"
                  class="form"
                >
                  <h4>Now, let's setup your account.</h4>

                  <fieldset>
                    <!-- <legend>Personal Information</legend> -->

                    <div class="form-grid">
                      <div class="column is-12">
                        <h5>
                          Please confirm your name, email, and password.
                        </h5>
                      </div>

                      <div class="column is-6">
                        <valid-input
                          type="text"
                          vid="firstName"
                          placeholder="First Name"
                          rules="required"
                          autocomplete="off"
                          v-model="formData.firstName"
                        />
                      </div>

                      <div class="column is-6">
                        <valid-input
                          type="text"
                          vid="lastName"
                          placeholder="Last name"
                          rules="required"
                          v-model="formData.lastName"
                        />
                      </div>

                      <div class="column is-12">
                        <valid-input
                          type="email"
                          vid="email"
                          placeholder="Email"
                          icon="email"
                          rules="required|email"
                          v-model="formData.email"
                        />
                      </div>

                      <!-- <div class="column is-12">
                        <valid-input
                          type="phone"
                          vid="phoneNumber"
                          placeholder="Phone"
                          icon="phone"
                          v-model="formData.phoneNumber"
                        />
                      </div> -->
                    </div>
                  </fieldset>

                  <fieldset>
                    <!-- <legend>Password</legend> -->
                    <div class="form-grid">
                      <div class="column">
                        <valid-input
                          name="password"
                          vid="password"
                          type="password"
                          placeholder="Password"
                          icon="lock"
                          rules="required|min:6"
                          v-model="formData.password"
                        />
                      </div>
                    </div>
                  </fieldset>

                  <div>
                    <a
                      href="https://hoamyway.com/portal-terms-and-conditions"
                      alt="View Terms and Conditions"
                      target="_blank"
                      >View Terms and Conditions</a
                    >
                  </div>

                  <fieldset>
                    <ValidationProvider vid="terms" rules="required" v-slot="{ errors }">
                      <div class="field">
                        <b-checkbox v-model="formData.agreeToTerms" required>
                          I agree to the Terms &amp; Conditions
                        </b-checkbox>
                        <span>{{ errors[0] }}</span>
                      </div>
                    </ValidationProvider>
                  </fieldset>

                  <div
                    v-if="status === STATUS_ERROR"
                    class="has-responsive-type has-text-centered error-box"
                  >
                    <h4>An error has occured.</h4>
                    <p>{{ errorMsg }}</p>
                  </div>

                  <button
                    type="submit"
                    class="button is-primary is-fullwidth"
                    :disabled="status === STATUS_SUBMITTED"
                  >
                    Submit Registration
                  </button>
                </form>

                <div
                  v-else-if="status === STATUS_COMPLETE"
                  class="has-responsive-type has-text-centered"
                >
                  <h4>
                    Thank you for registering.
                  </h4>
                  <div class="content">
                    <p>Your information has been received.</p>
                    <p>
                      Please check your email for a confirmation link.
                    </p>
                  </div>
                </div>
              </transition>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */

import { ValidationObserver, ValidationProvider } from 'vee-validate'

// services
import registration from '@/services/registration'
import { ValidationError } from '@/services/errors'

// components
import ValidInput from '@/components/inputs/ValidInput'
import ValidSelect from '@/components/inputs/ValidSelect'
import JsonBox from '@/components/JsonBox'

// static data
// import unitedStates from '@/services/usStates.json'

let DEFAULT_FORM_VALUES = {
  email: '',
  firstName: '',
  lastName: '',
  password: '',
  agreeToTerms: true
}

const STATUS_ERROR = -1
const STATUS_INIT = 0
const STATUS_LOADING = 1
const STATUS_CODE_VALID = 2
const STATUS_VERIFIED = 3
const STATUS_SUBMITTED = 4
const STATUS_COMPLETE = 5

export default {
  components: {
    ValidInput,
    ValidSelect,
    ValidationObserver,
    ValidationProvider,
    JsonBox
  },

  data: function() {
    return {
      isDebug: true,
      formComplete: false,
      formData: {
        ...DEFAULT_FORM_VALUES
      },
      validUnit: null,
      validUnits: [],
      isLease: false,
      errorMsg: null,
      status: STATUS_INIT,
      activeStep: 0,

      STATUS_ERROR,
      STATUS_INIT,
      STATUS_LOADING,
      STATUS_CODE_VALID,
      STATUS_VERIFIED,
      STATUS_SUBMITTED,
      STATUS_COMPLETE,

      form: {
        amount: [],
        amountId: [],
        amountPeriod: []
      }
    }
  },

  async mounted() {
    this.resetForm()

    const { code } = this.$route.params
    this.errorMsg = ''

    this.status = STATUS_LOADING

    if (this.$route.query.email && this.$route.query.email != undefined) {
      this.formData.email = this.$route.query.email
    }

    if (code) {
      var isError = false
      try {
        this.validUnits = await registration.ValidateOneOrManyOwnerSignupCode(code)
        if (this.validUnits !== undefined && this.validUnits) {
          let counter = 0
          Array.from(this.validUnits).forEach(element => {
            if (element && element != undefined) {
              element.id = counter
              counter++
            }
          })

          if (this.validUnits.length === 1) {
            this.validUnit = this.validUnits[0]
          }
        } else {
          throw new Error('The unit is not valid.')
        }

        this.status = STATUS_CODE_VALID
        this.isLease = false
      } catch (e) {
        isError = true
      }

      if (isError === true) {
        isError = false
        try {
          this.validUnit = await registration.ValidateLeaseSignupCode(code)
          this.status = STATUS_CODE_VALID
          this.isLease = true
        } catch (e) {
          isError = true
        }
      }

      if (isError === true) {
        this.error('This link is not valid. The sign up code may have expired.')
      }
    }
  },

  methods: {
    error(msg) {
      console.log('error(): ' + msg)
      this.status = STATUS_ERROR
      this.errorMsg = msg
    },

    resetForm() {
      this.formData = { ...DEFAULT_FORM_VALUES }
      this.activeStep = 0
      if (this.$refs.form) {
        this.$refs.form.reset()
      }
    },

    verify() {
      this.status = STATUS_VERIFIED
      // try to get first and last name from code result
      const [firstName, lastName] = this.validUnit.ownerName.split(' ')
      this.formData.firstName = firstName
      this.formData.lastName = lastName
      this.activeStep = 1
    },

    verifyOwners() {
      this.status = STATUS_VERIFIED
      // try to get first and last name from code result
      const [firstName, lastName] = this.validUnits[0].ownerName.split(' ')
      this.formData.firstName = firstName
      this.formData.lastName = lastName
      this.activeStep = 1
    },

    getFormPayload() {
      const payload = { ...this.formData }
      const { code } = this.$route.params
      // payload.unitCount = parseInt(payload.unitCount)

      payload.signupCode = code
      return payload
    },

    nextWizardStepAfterTwoFactor() {
      this.activeStep = 3
    },

    async onFormSubmit() {
      try {
        this.status = STATUS_SUBMITTED

        if (this.validUnits !== null && this.validUnits) {
          const results = await registration.RegisterOwnerOrOwners(this.getFormPayload())
          console.log('register results: ' + JSON.stringify(results))
          this.status = STATUS_COMPLETE
          this.activeStep = 2
        }

        // this.resetForm()
      } catch (e) {
        console.log('register exception: ' + JSON.stringify(e))
        // If this is a validation error, get the details for each field
        if (e instanceof ValidationError) {
          this.$refs.form.setErrors(e.fields)
        } else {
          // Default. Pass error message to last field on the form
          console.log('default error message: ' + e.message)
          this.$refs.form.setErrors({
            password: [e.message]
          })
          this.error(e.message)
        }
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.error-box {
  background-color: #ffaaaa;
  border-radius: 5px;
  padding: 10px;
  margin: 10px;
}
</style>
